export default "__VITE_ASSET__AGrV35kn__"